export default __webpack_public_path__ + "static/media/delete-sm.ebd47ca9.svg";